import { useTranslate } from "ra-core";
import { AddTask } from "@/components/atomic-crm/tasks/AddTask";
import { TasksListContent } from "@/components/atomic-crm/tasks/TasksListContent";
import { TaskActionsScope } from "@/components/gavion/tasks/taskActionsScope";

/** Desktop /tasks list (upstream only ships a mobile one); GAVION: « Nouvelle tâche » (a compagnie, optionally a contact). */
export const TasksPage = () => {
  const translate = useTranslate();
  return (
    <div className="mx-auto max-w-3xl space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-2xl font-extrabold">
          {translate("resources.tasks.name", { smart_count: 2 })}
        </h1>
        <AddTask selectCompany display="button" />
      </div>
      {/* GAVION task actions: each open task with a compagnie gets Appeler / Courriel / Noter / Contexte */}
      <TaskActionsScope.Provider value={true}>
        <TasksListContent />
      </TaskActionsScope.Provider>
    </div>
  );
};
